// Google Shopping product page, two new tops (FUEL_39 relaunch). Runs only while ab-shop-hero-v1 or
// ab-shop-hero-v2 is on <html> next to ab-shop-experience-v2; styles are in ab-shop-hero.css.
// - Desktop: the product information moves from under the photos into one row under the top.
// - Size chart link next to the size option (the original link stays in place, hidden, and is clicked for the popup).
// - V1: size and colour dropdowns that pick the existing option buttons, so the product form works as before.
{
  const LAYOUT_CLASS = 'ab-shop-experience-v2';
  const HERO_CLASSES = ['ab-shop-hero-v1', 'ab-shop-hero-v2'];
  const DESKTOP = window.matchMedia('(min-width: 992px)');
  const html = document.documentElement;

  const heroClass = () =>
    html.classList.contains(LAYOUT_CLASS) ? HERO_CLASSES.find((name) => html.classList.contains(name)) : null;

  const optionName = (wrapper) =>
    wrapper.querySelector('.radio__legend__option-name')?.textContent.trim() || '';

  const isSizeOption = (wrapper) => /size/i.test(optionName(wrapper));

  const placeInfo = (root) => {
    const slot = root.querySelector('[data-pdp-hero-info]');
    const home = root.querySelector('.pdp-cro-tab-com-main-desktop');
    if (!slot || !home) return;
    const info = slot.querySelector('.pdp-cro-desc-bottom-part') || home.querySelector(':scope > .pdp-cro-desc-bottom-part');
    if (!info) return;
    if (heroClass() && DESKTOP.matches) {
      if (info.parentNode !== slot) slot.appendChild(info);
    } else if (info.parentNode !== home) {
      home.prepend(info);
    }
  };

  const sizeWrapper = (root) => [...root.querySelectorAll('.product__selectors > .selector-wrapper')].find(isSizeOption);

  // The theme puts the link in its own box for "Hat Size", and inside the option's legend for a plain "Size".
  const sizeGuideButton = (root) => {
    const link =
      root.querySelector('.product__form__outer > .radio__fieldset--single .radio__legend__link') ||
      sizeWrapper(root)?.querySelector('.radio__legend__link');
    if (!link) return null;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ab-hero-size-guide';
    button.textContent = link.textContent.trim() || 'Size chart';
    button.addEventListener('click', () => {
      link.click();
      // Focus comes back to this button, not the hidden link, when the popup closes.
      if (window.accessibility) window.accessibility.lastElement = button;
    });
    return button;
  };

  // V2 shows the existing size buttons, so the link goes into their legend.
  const placeSizeGuide = (root) => {
    const legend = sizeWrapper(root)?.querySelector('.radio__legend');
    if (!legend || legend.querySelector('.ab-hero-size-guide')) return;
    const button = sizeGuideButton(root);
    if (button) legend.appendChild(button);
  };

  const swatchFill = (wrapper, value) => {
    const input = [...wrapper.querySelectorAll('input[type="radio"]')].find((item) => item.value === value);
    const swatch = input?.closest('.swatch__button');
    if (!swatch) return null;
    for (const el of [swatch.querySelector('label'), swatch]) {
      if (!el) continue;
      const style = getComputedStyle(el);
      const image = style.backgroundImage !== 'none' ? style.backgroundImage : '';
      const color = style.backgroundColor;
      if (image || (color && color !== 'rgba(0, 0, 0, 0)' && color !== 'transparent')) return { image, color };
    }
    return null;
  };

  const syncSelect = (select, wrapper) => {
    const inputs = [...wrapper.querySelectorAll('input[type="radio"]')];
    inputs.forEach((input, index) => {
      const option = select.options[index];
      if (!option) return;
      option.disabled = input.disabled;
      const soldOut = input.classList.contains('sold-out') || input.classList.contains('unavailable');
      option.textContent = soldOut ? `${input.value} - ${window.theme?.strings?.soldOut || 'Sold out'}` : input.value;
    });
    const checked = inputs.find((input) => input.checked);
    if (checked) select.value = checked.value;

    const chip = select.parentNode.querySelector('.ab-hero-select__chip');
    if (!chip) return;
    const fill = swatchFill(wrapper, select.value);
    chip.style.backgroundColor = fill?.color || '';
    chip.style.backgroundImage = fill?.image || '';
  };

  const buildSelect = (root, wrapper, index) => {
    const isSwatch = Boolean(wrapper.querySelector('.radio__fieldset--swatches'));
    const id = `AbHeroSelect-${index}`;
    const item = document.createElement('div');
    item.className = `ab-hero-select${isSwatch ? ' ab-hero-select--color' : ''}`;

    const head = document.createElement('div');
    head.className = 'ab-hero-select__head';
    const label = document.createElement('label');
    label.className = 'ab-hero-select__label';
    label.htmlFor = id;
    label.textContent = optionName(wrapper);
    head.appendChild(label);
    if (isSizeOption(wrapper)) {
      const button = sizeGuideButton(root);
      if (button) head.appendChild(button);
    }

    const box = document.createElement('div');
    box.className = 'ab-hero-select__box';
    if (isSwatch) {
      const chip = document.createElement('span');
      chip.className = 'ab-hero-select__chip';
      chip.setAttribute('aria-hidden', 'true');
      box.appendChild(chip);
    }
    const select = document.createElement('select');
    select.id = id;
    select.className = 'ab-hero-select__field';
    wrapper.querySelectorAll('input[type="radio"]').forEach((input) => {
      select.add(new Option(input.value, input.value));
    });
    select.addEventListener('change', () => {
      const input = [...wrapper.querySelectorAll('input[type="radio"]')].find((radio) => radio.value === select.value);
      if (input && !input.checked) input.click();
      syncSelect(select, wrapper);
    });
    box.appendChild(select);

    item.append(head, box);
    syncSelect(select, wrapper);
    return { item, select, wrapper };
  };

  let selects = [];

  // V1: the dropdowns sit above the hidden option buttons, size first.
  const placeSelects = (root) => {
    const selectors = root.querySelector('.product__selectors');
    if (!selectors || selectors.querySelector('.ab-hero-selects')) return;
    const wrappers = [...selectors.querySelectorAll(':scope > .selector-wrapper')].filter((wrapper) =>
      wrapper.querySelector('input[type="radio"]'),
    );
    if (!wrappers.length) return;
    wrappers.sort((a, b) => Number(isSizeOption(b)) - Number(isSizeOption(a)));

    const row = document.createElement('div');
    row.className = 'ab-hero-selects';
    selects = wrappers.map((wrapper, index) => buildSelect(root, wrapper, index));
    selects.forEach(({ item }) => row.appendChild(item));
    selectors.prepend(row);
  };

  const syncSelects = () => selects.forEach(({ select, wrapper }) => syncSelect(select, wrapper));

  const run = () => {
    const root = document.querySelector('.index-product[data-section-type="product"]');
    if (!root) return;
    placeInfo(root);
    const hero = heroClass();
    if (hero === 'ab-shop-hero-v1') placeSelects(root);
    if (hero === 'ab-shop-hero-v2') placeSizeGuide(root);
  };

  run();
  new MutationObserver(run).observe(html, { attributes: true, attributeFilter: ['class'] });
  DESKTOP.addEventListener('change', run);
  document.addEventListener('theme:variant:change', () => requestAnimationFrame(syncSelects));
}
